import { render, staticRenderFns } from "./AwardInfo.vue?vue&type=template&id=5bbed204&"
import script from "./AwardInfo.vue?vue&type=script&lang=js&"
export * from "./AwardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports